type AppliedCampaign = {
  loyalty_discount_amount?: number;
  loyalty_discount_points?: number | null;
  loyalty_discount_uuid?: string;
};

export type CartType = {
  id: string | null | undefined;
  free_shipping_threshold?: number | null;
  is_trial_eligible?: boolean;
  can_apply_coupons?: boolean;
  applied_campaign?: AppliedCampaign;
  available_payment_methods?: Array<{ code: string; title: string }>;
};
